// replace("Hello {0}! Welcome to {1}.", ['foo', 'bar'])
//  => Hello foo! Welcome to bar.
const replace = (string, replaces) =>
  string.replace(/{(\d+)}/g, (match, index) =>
    typeof replaces[index] !== 'undefined' ? replaces[index] : match,
  )

export default replace
